<template>
  <div class="leavingHome">
    <baseBg bgUrl="leavingbg"></baseBg>
    <el-form
      :model="dataObj"
      ref="dataObjForm"
      label-width="0px"
      class="leavingBox"
      :rules="rules"
    >
      <div class="box-title">留言反馈</div>
      <div class="he50"></div>
      <div class="box-name">留言主题</div>
      <el-form-item prop="title">
        <el-input
          v-model="dataObj.title"
          placeholder="请输入留言主题"
        ></el-input>
      </el-form-item>
      <div class="box-name">联系人</div>
      <el-form-item prop="name">
        <el-input v-model="dataObj.name" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <div class="box-name">联系方式</div>
      <div class="boxlist">
        <div class="box-img">
          <span :class="{ spanAct: typeItem === '1' }" @click="tabClick('1')">
            <img src="../../../assets/img/about/iphone.png" alt />
          </span>
          <span :class="{ spanAct: typeItem === '2' }" @click="tabClick('2')">
            <img src="../../../assets/img/about/qq.png" alt />
          </span>
          <span :class="{ spanAct: typeItem === '3' }" @click="tabClick('3')">
            <img src="../../../assets/img/about/em.png" alt />
          </span>
        </div>
        <el-form-item prop="mobile" v-if="typeItem === '1'">
          <el-input
            v-model="dataObj.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="qqNumber" v-if="typeItem === '2'">
          <el-input
            v-model="dataObj.qqNumber"
            placeholder="请输入qq号码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="email" v-if="typeItem === '3'">
          <el-input
            v-model="dataObj.email"
            placeholder="请输入邮箱号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="box-name">备注</div>
      <el-form-item prop="note">
        <el-input v-model="dataObj.note" type="textarea" :rows="5"></el-input>
      </el-form-item>
      <div class="he50"></div>
      <div class="leavbutton" @click="submitForm('dataObjForm')">
        立即提交留言
      </div>
    </el-form>
    <div class="he50"></div>
    <div class="he50"></div>
  </div>
</template>

<script>
import baseBg from "@/components/pc/base/bg.vue";
import { addConsult } from "@/api/api.js";

export default {
  components: {
    baseBg
  },
  data() {
    const checkAge = (rule, value, callback) => {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (value === "" && this.typeItem === "1") {
        callback(new Error("手机号不能为空"));
      } else if (!myreg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const qqNumber = (rule, value, callback) => {
      let regex = /^[1-9][0-9]{4,9}$/;
      if (value === "" && this.typeItem === "2") {
        callback(new Error("qq号不能为空"));
      } else if (!regex.test(value)) {
        callback(new Error("请输入正确的qq号"));
      } else {
        callback();
      }
    };
    const email = (rule, value, callback) => {
      let myreg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (value === "" && this.typeItem === "3") {
        callback(new Error("邮箱不能为空"));
      } else if (!myreg.test(value)) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    //
    return {
      typeItem: "1",
      input: "",
      dataObj: {
        title: "",
        name: "",
        mobile: "",
        qqNumber: "",
        email: "",
        note: "",
        periodicalId: ""
      },
      rules: {
        title: [{ required: true, message: "主题不能为空" }],
        name: [{ required: true, message: "名字不能为空" }],
        mobile: [{ validator: checkAge, trigger: "blur" }],
        qqNumber: [{ validator: qqNumber, trigger: "blur" }],
        email: [{ validator: email, trigger: "blur" }],
        note: [{ required: false }]
      }
    };
  },
  methods: {
    tabClick(tab) {
      this.dataObj.mobile = "";
      this.dataObj.qqNumber = "";
      this.dataObj.email = "";
      this.typeItem = tab;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addConsult();
        } else {
          return false;
        }
      });
    },
    addConsult() {
      addConsult(this.dataObj).then(res => {
        if (res.code === 0) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.typeItem = "1";
          this.$refs.dataObjForm.resetFields();
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>
<style lang="less">
.leavingBox {
  margin: 0 auto;
  padding: 50px 80px;
  width: 700px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 16px 0px rgba(46, 32, 45, 0.1);
  border-radius: 10px;
  box-sizing: border-box;
  .box-title {
    font-size: 36px;
    font-weight: bold;
    color: rgba(52, 52, 52, 1);
    line-height: 28px;
    text-align: center;
  }
  .box-name {
    font-size: 16px;
    font-weight: 400;
    color: rgba(52, 52, 52, 1);
    line-height: 28px;
  }
  .boxlist {
    display: flex;
    justify-content: space-between;
    .box-img {
      display: flex;
      justify-content: space-around;
      width: 200px;
      span {
        display: inline-block;
        width: 40px;
        height: 40px;
        line-height: 38px;
        text-align: center;
        border: 1px solid #dcdfe6;
        //
        border-radius: 2px;
        box-sizing: border-box;
      }
      .spanAct {
        border: 1px solid rgba(108, 44, 102, 1);
      }
    }
    .el-form-item {
      width: calc(100% - 200px);
    }
  }
  .leavbutton {
    margin: 0 auto;
    width: 180px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background: rgba(108, 44, 102, 1);
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
  }
}
</style>
